# import * from "./money.graphql"
# import * from "./discount.graphql"
# import * from "./payment-link-support.graphql"

fragment basketFields on Basket {
  id
  client {
    id
    name
    mobile
    email
    firstName
    lastName
    isWalkIn
    preferredStaffId
    creditTerms {
      creditDays
      creditLimit
    }
    creditAccount {
      outstandingBalance
    }
    treatCard {
      serial
    }
    treatCardAccount {
      points
    }
    gender
  }
  responsibleStaffMember {
    id
    name
    firstName
    lastName
    avatar {
      medium
    }
  }
  changeAmount {
    ...moneyFields
  }
  discountAmount {
    ...moneyFields
  }
  totalInternetDiscountAmount {
    ...moneyFields
  }
  totalDepositAmount {
    ...moneyFields
  }
  taxAmount {
    ...moneyFields
  }
  totalToPay {
    ...moneyFields
  }
  totalServicesAmount {
    ...moneyFields
  }
  totalProductsAmount {
    ...moneyFields
  }
  tipAmount {
    ...moneyFields
  }
  totalTippableAmount {
    ...moneyFields
  }
  totalSurchargeAmount {
    ...moneyFields
  }
  originalBasketToTipId
  tip {
    requestedTip {
      type
      value
    }
    staffMemberTips {
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      tipAmount {
        ...moneyFields
      }
    }
  }
  terminalTippableStaffMembers {
    staffMember {
      id
      name
      firstName
      lastName
      avatar {
        medium
        __typename
      }
    }
    __typename
  }
  taxIncluded
  tillId
  purchaseId
  editedPurchaseId
  refundedPurchaseId
  manualTippingEnabled
  isStrictPOSEnabledAndTillSessionCounted
  willDeleteCashUpOnCheckout
  wholeBasketDiscount {
    ...discountFields
  }
  totalMembershipBenefitGross {
    ...moneyFields
  }
  membershipStoredCardMissing
  payments {
    __typename
    ... on BasketIntegratedPayment {
      id
      type
      amount {
        ...moneyFields
      }
      saveCardDetails
      feeType
      status
      cardDetails {
        brand
        lastFourDigits
        paymentsPaymentMethodType
        paymentMethodDescription
        paymentMethodDetails
      }
      bnplDetails {
        paymentMethodDescription
        paymentMethodDetails
        paymentsPaymentMethodType
        bnplProvider
      }
      totalSurchargeAmount {
        ...moneyFields
      }
    }
    ... on BasketNonIntegratedPayment {
      id
      amount {
        ...moneyFields
      }
      paymentType
      supplementalPaymentTypeId
      voucher {
        id
        serial
        remainingBalance {
          ...moneyFields
        }
      }
    }
  }
  paymentLinkDetails {
    ...paymentLinkDetailsFields
  }
  paymentLinkId
  status
  createDate
  items {
    __typename
    ... on AppointmentBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      depositAmount {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      appointment {
        id
        state
        date
        serviceId
        isFinish
        hasFinish
        finishRelatedAppointmentId
        isAddon
        parentAppointmentId
        price {
          ...moneyFields
        }
        depositAmountMonetary {
          amount
          currency
        }
      }
      serviceId
      clientCourseConversionAvailable
      courseConversionAvailable
    }
    ... on AppointmentPackageBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      depositAmount {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      appointment {
        id
        serviceGroupId
        state
        date
        hasFinish
        finishRelatedAppointmentId
        depositAmountMonetary {
          amount
          currency
        }
        price {
          ...moneyFields
        }
      }
    }
    ... on AppointmentSpecialOfferBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      depositAmount {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      appointment {
        id
        serviceGroupId
        state
        date
        hasFinish
        finishRelatedAppointmentId
        depositAmountMonetary {
          amount
          currency
        }
        price {
          ...moneyFields
        }
      }
    }
    ... on AppointmentCourseSessionBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      depositAmount {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      appointment {
        id
        state
        date
        hasFinish
        finishRelatedAppointmentId
        depositAmountMonetary {
          amount
          currency
        }
      }
    }
    ... on ExtraAppointmentCostBasketItem {
      id
      quantity
      description
      unitPrice {
        ...moneyFields
      }
      totalPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      appointment {
        id
        state
        date
        depositAmountMonetary {
          amount
          currency
        }
        price {
          ...moneyFields
        }
      }
    }
    ... on CreditAccountBasketItem {
      id
      quantity
      description
      unitPrice {
        ...moneyFields
      }
      totalPrice {
        ...moneyFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on PackageBasketItem {
      id
      serviceGroupId
      serviceGroupOptionId
      quantity
      description
      unitPrice {
        ...moneyFields
      }
      totalPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on SpecialOfferBasketItem {
      id
      serviceGroupId
      serviceGroupOptionId
      quantity
      description
      unitPrice {
        ...moneyFields
      }
      totalPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on ProductBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      product {
        id
        measurement
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      overridePrice {
        ...moneyFields
      }
    }
    ... on PartialProductBasketItem {
      id
      quantity
      partialAmount
      unitType
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      product {
        id
        measurement
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      overridePrice {
        ...moneyFields
      }
    }
    ... on VoucherBasketItem {
      id
      description
      quantity
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      recipientClient {
        id
      }
      serial
      creditAmount
      voucherCampaign {
        id
        name
      }
    }
    ... on VoucherTopUpBasketItem {
      id
      description
      quantity
      serial
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on ServiceBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      overridePrice {
        ...moneyFields
      }
      service {
        id
        isAddonOnly
      }
    }
    ... on OpenSaleBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      openSalePrice {
        ...moneyFields
      }
      openSaleType
      taxRateIds
    }
    ... on SaleFeeBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discountAmount {
        ...moneyFields
      }
      saleFee {
        id
        type
        value
      }
    }
    ... on CreditAccountAppointmentDepositBasketItem {
      id
      description
      appointment {
        id
        color {
          hex
        }
        depositPaidMonetary {
          amount
          currency
        }
        depositAmountMonetary {
          amount
          currency
        }
        flags
      }
      appointmentId
      unitPrice {
        ...moneyFields
      }
      totalPrice {
        ...moneyFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on NoShowChargeBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      chargeAmount
      appointmentDate
      appointments {
        id
        state
      }
    }
    ... on CancellationChargeBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      chargeAmount
      deleteRecurrentAppointments
      appointmentIds
    }
    ... on CourseBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discountAmount {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      courseId
      overridePrice {
        ...moneyFields
      }
    }
    ... on ServiceRewardAppointmentBasketItem {
      id
      appointment {
        state
        hasFinish
        finishRelatedAppointmentId
        id
      }
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      points
    }
    ... on ServiceRewardBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      points
    }
    ... on ProductRewardBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      points
    }
    ... on OfflineDepositBasketItem {
      id
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on OnlineDepositBasketItem {
      id
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on CourseSessionBasketItem {
      id
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      quantity
      consumedUnits
      remainingUnits
      unitType
    }
    ... on MembershipBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      clientMembershipTermsId
      clientMembershipTerms {
        status
      }
    }
    ... on AvedaMembershipBasketItem {
      id
      description
      quantity
      unitPrice {
        ...moneyFields
      }
      totalPrice {
        ...moneyFields
      }
      grossTotalPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on MembershipBillingEventBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      discount {
        ...discountFields
      }
      discountAmount {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
    }
    ... on ThirdPartyProductRewardBasketItem {
      id
      quantity
      description
      totalPrice {
        ...moneyFields
      }
      unitPrice {
        ...moneyFields
      }
      staffMember {
        id
        name
        firstName
        lastName
        avatar {
          medium
        }
      }
      thirdPartyProductRewardId
      thirdPartyRewardProgramName
    }
  }
  avedaCertificates {
    issuanceUniqueId
    description
    offerCode
    quantity
    staffMember {
      id
      name
    }
  }
}
